import { useParticipantsPersonEventsApi } from '@/features/api/hooks/participant/useParticipantsPersonEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const usePersonResendVerificationEmail = () => {
  const api = useParticipantsPersonEventsApi();

  return useApiMutation({
    mutationFn: () => api.onPersonResendVerificationEmailRequest({}),
    successMessageKey: 'resendVerificationEmail.success'
  });
};
